
export default function ExerciserValidationButton({onValidateButtonPressed, isDisabled}) {
    // Used to display a validating component that needs a slide gesture
    // to validate user entry

    // BUILD
    return (
        <div className={`w-full h-[48px] flex justify-center items-center rounded-full select-none ${renderButtonStyle()} font-medium`}
             onClick={onValidateButtonPressed}>
            <span className={""}>
                {"Valider"}
            </span>
        </div>
    );

    // METHODS
    // ---- UI : Render button style
    function renderButtonStyle() {
        return isDisabled
            ? "cursor-not-allowed bg-greyLight1 text-greyLight7"
            : "cursor-pointer bg-primaryLight1 text-white";
    }
}